<template>
	<div class="search-list">
		<div class="noData" v-if="noData">
			<!-- <img src="../../assets/images/noData1.png" alt=""> -->
			<p>没有搜索到任何数据</p>
		</div>
		<div class="meetings">
			<template v-for="item in articlesList">
				<item-block :itemContent="item"    :key="item.id"></item-block>
			</template>
		</div>
	</div>
</template>
<script>
	import ExpertInfo from "@/components/Expert/ExpertInfo"
	import ItemBlock from "@/components/ItemBlock"
	import {SearchArticles} from "@/config/interface.js"
	export default{
		data(){
			return{
				searchKeyWord:'',    //关键词
				articlesList:[],    //文章列表
				channel_id:0,
				instrumentsType:2,
				noData:false
			}
		},
		components:{
			ExpertInfo,
			ItemBlock
		},
		mounted(){
			this.searchKeyWord=this.$route.query.searchKeyWord;
			this.channel_id=localStorage.getItem('channel_id')?JSON.parse(localStorage.getItem('channel_id')).channel_id:0;
			this.getSearchList();
		},
		methods:{
			//搜索列表
			getSearchList(){
				const url=SearchArticles;
				const method='POST';
				let params={
					keywords:this.searchKeyWord,
					channel_id:this.channel_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.articlesList=data.articles;
						let regExp = new RegExp(this.searchKeyWord, 'g');
						this.articlesList.forEach((item,index)=>{
							// let index=item.name.indexOf(this.searchKeyWord);
							item.name= item.name.replace(regExp, "<span class='highlight'>" + this.searchKeyWord + '</span>'); //将找到的关键字替换，加上highlight属性；
							// item.name
							// console.log(item.name.length)
							// console.log(item.name.indexOf(this.searchKeyWord))
						})
						this.noData=this.articlesList.length>0?false:true;
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.search-list{
		padding:14px 12px;
		.noData{
			position:absolute;
			left:50%;
			top:30%;
			transform:translate(-50%,-50%);
			img{
				width:220px;
			}
			p{
				margin-top: 10px;
				text-align:center;
				color: #666;
				font-size:14px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Vow/Search/List.vue